import Auth from '../../../../auth';

const EVENT_TRACKING_NAME = 'MaintenancePlanDetails';
const EVENT_TRACKING_ACTIONS = {
  editButtonClicked: 'editButtonClicked',
  deleteButtonClicked: 'deleteButtonClicked',
}

const addToDataLayer = (data) => {
  window.dataLayer.push({
    event: EVENT_TRACKING_NAME,
    data: { ...data },
  })
}
export default function MaintenancePlansDetailsController(
  $scope,
  $stateParams,
  $uibModal,
  MaintenanceService,
  gettextCatalog
) {
  'ngInject';

  //Pagination of document links
  $scope.currentPage = 1;
  $scope.itemsPerPage = 5;
  $scope.maxSize = 1;
  $scope.documentLinks = [];
  $scope.maxEmails = 10;
  $scope.initLoading = true;
  /**
      -- Edit/Cancel Button --
  */
  $scope.editButtonClicked = function() {
    
    addToDataLayer({
      action: EVENT_TRACKING_ACTIONS.editButtonClicked,
    });

    $scope.isEditing = !$scope.isEditing;

    $scope.editingDocLinkFlag = {}; //for maintenance doc link
    $scope.disabledEditing = false; //for maintennace doc link

    if ($scope.isEditing) {
      $scope.plan = angular.copy($scope.maintenancePlanData);
    }
  };
  $scope.$on('totalEmails', function(event, totalEmails) {
    $scope.maxEmails = totalEmails.length;
  });

  $scope.$on('disableMeter', function(event, args) {
    $scope.meter_checked = args.Meter;
  });

  $scope.$on('disableDate', function(event, args) {
    $scope.date_checked = args.Calendar;
  });

  $scope.$on('meterRulesChange', function(event, args) {
    $scope.meter_rules = args.MeterRules;
  });

  $scope.$on('calendarRulesChange', function(event, args) {
    $scope.calendar_rules = args.CalendarRules;
  });

  $scope.deleteButtonPressed = function() {

    addToDataLayer({
      action: EVENT_TRACKING_ACTIONS.deleteButtonClicked,
    });

    $scope.deleted = true;

    let modalInstance = $uibModal.open({
      animation: true,
      template: require('./delete/delete.html'),
      controller: 'MaintenancePlansDeleteModalController',
      resolve: {
        plan: () => $scope.maintenancePlanData
      },
      size: 'md'
    });
  };
  $scope.notValid = false;
  $scope.putMaintenance = function() {
    $scope.userForm.$submitted = true;
    $scope.errorFlag = false;
    //One or the other must be checked
    if (($scope.meter_checked || $scope.date_checked) && $scope.userForm.$valid) {
      //Check to see if the number of emails in the plan is greater than the max
      if ($scope.plan.contacts.length <= $scope.maxEmails) {
        if ($scope.meter_checked == true) {
          var count = 0;
          for (var i = 0; i < $scope.plan.recurrence.rules.length; i++) {
            if (
              $scope.plan.recurrence.rules[i].type == 'odometer' ||
              $scope.plan.recurrence.rules[i].type == 'runhour'
            ) {
              $scope.plan.recurrence.rules[i] = $scope.meter_rules[0];
            } else {
              count++;
            }
          }
          if (count == $scope.plan.recurrence.rules.length) {
            $scope.plan.recurrence.rules.push($scope.meter_rules[0]);
          }
        } else if ($scope.meter_checked == false) {
          for (var i = 0; i < $scope.plan.recurrence.rules.length; i++) {
            if (
              $scope.plan.recurrence.rules[i].type == 'odometer' ||
              $scope.plan.recurrence.rules[i].type == 'runhour'
            ) {
              $scope.plan.recurrence.rules.splice(i, 1);
            }
          }
        }
        if ($scope.date_checked == true) {
          var count = 0;
          for (var i = 0; i < $scope.plan.recurrence.rules.length; i++) {
            if ($scope.plan.recurrence.rules[i].type == 'date') {
              $scope.plan.recurrence.rules[i] = $scope.calendar_rules[0];
            } else {
              count++;
            }
          }
          if (count == $scope.plan.recurrence.rules.length) {
            $scope.plan.recurrence.rules.push($scope.calendar_rules[0]);
          }
        } else if ($scope.date_checked == false) {
          for (var i = 0; i < $scope.plan.recurrence.rules.length; i++) {
            if ($scope.plan.recurrence.rules[i].type == 'date') {
              $scope.plan.recurrence.rules.splice(i, 1);
            }
          }
        }

        //tag-input directive will change plane.tags to array of objects after editing
        //need to put it back to array of string
        let stringTagsArray = $scope.plan.tags.map(function(tag) {
          return tag.text.toLowerCase();
        });
        $scope.plan.tags = stringTagsArray;

        if ($scope.documentLinks.length >= 1) {
          $scope.plan.documentLinks = $scope.documentLinks;
        }

        const brand = Auth.getBrandClaim();
        if (brand != null && $scope.plan.attrs.brand === undefined) {
          $scope.plan.attrs.brand = brand;
        }

        $scope.loading = true;
        MaintenanceService.updatePlan($scope.plan).then(
          function(response) {
            $scope.notValid = false;
            $scope.maintenancePlanData = response.data;
            //Set editing plan to be false after we have sucessfully finished the put
            $scope.isEditing = false;
            $scope.loading = false;
          },
          function(error) {
            $scope.loading = false;
            $scope.isEditing = true;
            let errorMsg = gettextCatalog.getString('An error occurred while editing the maintenance plan');
            if (error.status == 409) {
              errorMsg =
                gettextCatalog.getString('The name ') +
                $scope.plan.name +
                gettextCatalog.getString(' already exists. Please rename the Maintenance Plan.');
            }
            if ((error.data || error.status) && error.status != 409) {
              if (error.data && error.statusText) {
                errorMsg = error.data + ' ' + error.statusText + ' : ' + error.status.toString();
              }
              if (error.data) {
                errorMsg = error.data + ' ' + error.status.toString();
              } else {
                errorMsg += ': ' + error.status.toString();
              }
            }
            $scope.errorFlag = true;
            $scope.errorText = errorMsg;
          }
        );
      }
    } else {
      if (!($scope.meter_checked || $scope.date_checked)) {
        $scope.notValid = true;
      }
    }
  };

  $scope.editButtonPressed = function() {
    let modalInstance = $uibModal.open({
      animation: true,
      template: require('./edit/edit.html'),
      controller: function(maintenancePlan) {},
      size: 'md',
      resolve: {
        maintenancePlan: function() {
          return $scope.maintenancePlanData;
        }
      }
    });
  };

  let refresh = function() {
    MaintenanceService.getPlan($stateParams.id).then(
      function(response) {
        $scope.initLoading = false;
        $scope.maintenancePlanData = response.data;

        $scope.$emit('$viewContentLoaded');

        if ($scope.maintenancePlanData.documentLinks.length >= 1) {
          $scope.documentLinks = $scope.maintenancePlanData.documentLinks;
        }

        for (let i = 0; i < $scope.maintenancePlanData.recurrence.rules.length; i++) {
          if (
            $scope.maintenancePlanData.recurrence.rules[i].type == 'odometer' ||
            $scope.maintenancePlanData.recurrence.rules[i].type == 'runhour'
          ) {
            $scope.meter_checked = true;
          }
          if ($scope.maintenancePlanData.recurrence.rules[i].type == 'date') {
            $scope.date_checked = true;
          }
        }
      },
      function(error) {
        let errorMsg = gettextCatalog.getString('An error occurred while retrieving maintenance plan data');
        if (error.data || error.status) {
          if (error.data.message) {
            errorMsg = error.data.message + ' ' + error.status.toString();
          } else {
            errorMsg += ': ' + error.status.toString();
          }
        } else {
          errorMsg += gettextCatalog.getString('. Please try again later.');
        }
        $scope.onLoadErrorFlag = true;
        $scope.onLoadErrorText = errorMsg;
        $scope.initLoading = false;
      }
    );
  };

  //Sort doc links
  $scope.orderDocumentLinksFilter = function(predicate) {
    if (predicate === $scope.predicate) {
      $scope.reverse = !$scope.reverse;
    } else {
      $scope.reverse = false;
    }
    $scope.predicate = predicate;

    angular.forEach($scope.documentLinks, function(docLinks) {
      docLinks[predicate] = docLinks[predicate];
    });

    $scope.documentLinks = $filter('orderBy')($scope.documentLinks, predicate, $scope.reverse);
  };

  refresh();
}
